'use client';

import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import { ROUTES } from '@openclassrooms/routing';
import PushPathListBanner from '@openclassrooms/common-app/PushPathListBanner';
const PushPathListBannerWrapper = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PushPathListBanner title={translate("student_experience.closer.title")} text={translate("student_experience.closer.text")} cta={translate("student_experience.closer.cta")} buttonProps={{
      variant: "primary",
      href: ROUTES.PATH.INDEX
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PushPathListBannerWrapper;